import React from 'react';
import PropTypes from 'prop-types';

const ParseHtml = ({ className, children }) => (
  // eslint-disable-next-line react/no-danger
  <div className={className} dangerouslySetInnerHTML={{ __html: children }} />
);

ParseHtml.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
};

export default ParseHtml;
